import { render, staticRenderFns } from "./TabBadgeCounter.vue?vue&type=template&id=e631c8f6&"
import script from "./TabBadgeCounter.vue?vue&type=script&lang=ts&"
export * from "./TabBadgeCounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports